import React from 'react';
import { Link } from 'react-router-dom';
import { canOpenThread } from './skillsLogic';

/**
 * A chat thread reference. Chat sessions are stored per user, so the
 * /ai-assistant/:id route only opens threads the viewer owns; anyone else's
 * thread is shown as its id with the owner in the tooltip.
 */
export default function ThreadLink({ threadId, ownerId, viewerId, children }) {
  if (!threadId) return null;
  const short = threadId.length > 14 ? `${threadId.slice(0, 12)}…` : threadId;
  if (canOpenThread(ownerId, viewerId)) {
    return (
      <Link className="sk-thread" to={`/ai-assistant/${encodeURIComponent(threadId)}`} title={`Open thread ${threadId} in the assistant`}>
        {children || short}
      </Link>
    );
  }
  return (
    <span className="sk-thread sk-thread-off" title={`Thread ${threadId}${ownerId ? ` — started by ${ownerId}` : ''}. Only its owner can open it.`}>
      {children || short}
    </span>
  );
}
